mutation InvoiceSigningExportFilter($input: InvoiceSigningExportFilterInput!) {
  invoiceSigningExportFilter(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
